import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import required modules
import { Pagination } from 'swiper';
// Import Swiper styles
import 'swiper/swiper-bundle.css';
import { cx, css } from 'linaria';
import { theme } from '../../Theme';

const paginatedSliderStyle = css`
  --bullet-mix-color: white;
  --active-bullet-mix-color: black;
  --slider-background-color: #cdbdaf;

  width: 100%;
  .swiper-pagination {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px 40px 0 40px;
    max-width: 500px;
    margin: 0 auto;

    .swiper-pagination-bullet {
      flex: 1;
      border-radius: 0;
      background: color-mix(
        in srgb,
        var(--slider-background-color),
        var(--bullet-mix-color) 40%
      );
      transition: background 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      opacity: 1;
      margin: 0 4px;
      height: 6px;

      ${theme.below.md} {
        margin: 0 2px;
      }

      &:first-child {
        border-radius: 10px 0 0 10px;
      }

      &:last-child {
        border-radius: 0 10px 10px 0;
      }

      &.swiper-pagination-bullet-active {
        transition: background 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        background: color-mix(
          in srgb,
          var(--slider-background-color),
          var(--active-bullet-mix-color) 40%
        );
      }
    }
  }
`;

export const PaginatedSlider = ({ children, backgroundColor = '#ffffff' }) => {
  const whiteCheckList = ['#ffffff', '#fff', 'white'];
  const blackCheckList = ['#000000', '#000', 'black'];
  const whiteReplacementColor = '#e0e0e0';
  const blackReplacementColor = '#202020';
  let activeBackgroundColor;
  // Adjustments to pagination bullet color based on background color
  if (whiteCheckList?.includes(backgroundColor?.toLowerCase())) {
    activeBackgroundColor = whiteReplacementColor;
  } else if (blackCheckList?.includes(backgroundColor?.toLowerCase())) {
    activeBackgroundColor = blackReplacementColor;
  } else {
    activeBackgroundColor = backgroundColor;
  }

  return (
    <Swiper
      slidesPerView={1.5}
      spaceBetween={10}
      pagination={{
        clickable: true,
      }}
      modules={[Pagination]}
      className={cx('pagination-swiper', paginatedSliderStyle)}
      style={{ '--slider-background-color': activeBackgroundColor }}
      draggable={true}
      breakpoints={{
        // mobile (default)
        0: {
          slidesPerView: 1.5,
        },
        // tablets
        768: {
          slidesPerView: 2.5,
        },
        // desktops
        1024: {
          slidesPerView: 3.5,
        },
      }}
    >
      {children?.map((child) => (
        <SwiperSlide key={child?.key}>{child}</SwiperSlide>
      ))}
    </Swiper>
  );
};
